export const promotionInfo = {
	title: "Informações da promoção",
	description:
		"Defina todos os parâmetros necessários para criar uma promoção especializada para os seus clientes.",
	channelAndAudience: {
		title: "Canal e público alvo da promoção",
		description: "Escolha o canal para distribuição e quem poderá receber a promoção.",
		channelTitle: "Escolha o tipo de canal",
		channelInfo: "Define em qual canal de venda a promoção será distribuída e aplicada.",
		channels: {
			cashlessMesas: {
				title: "Cashless/Mesas",
				description: "Promoção aplicada na venda cashless ou mesas",
			},
			ficha: {
				title: "Ficha",
				description: "Promoção aplicada na venda ficha",
			},
			totemFicha: {
				title: "Totem Ficha",
				description: "Promoção aplicada no totem ficha",
			},
		},
		audienceTitle: "Quem poderá receber essa promoção?",
		audienceInfo:
			"Define quem pode receber a promoção e se será preciso informar o CPF do cliente na venda para aplicá-la.",
		audience: {
			everybody: "Todos os clientes",
			identifiedCpf: "Cliente identificado com CPF",
		},
		identifiedCpfWarning:
			"É necessário que os totens tenham conexão com internet para promoções com identificação de cliente.",
	},
	generalData: {
		title: "Dados gerais da promoção",
		description:
			"Informe o nome e descrição da promoção e os locais os quais ela estará atribuída.",
	},
	promotionName: {
		label: "Nome da Promoção",
		placeholder: "Digite o nome da promoção",
	},
	promotionDescription: {
		label: "Descrição da promoção",
		placeholder: "Descreva a descrição da promoção",
	},
	expiration: {
		label: "Expiração",
		info:
			"A promoção será válida até a data selecionada. Quando chegar a data de expiração, a promoção ficará inativa e você poderá alterar a data de expiração.",
		notExpire: "Não expira",
	},
	places: "Locais da promoção",
	placesAll: "Todos",
	errors: {
		requiredField: "Esse campo é obrigatório",
		dateFormat: "Formato de data inválido",
		dayDiff: "Necessário pelo menos um dia de diferença",
		selectPlace: "Selecione pelo menos um local",
		maxUses:
			"Valor não pode ser superior a quantidade de produtos definida no passo anterior",
	},
};
